import { BlueprintInstanceType } from '@rta/rta-blueprint-library';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const insertBreakpointMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Insert Breakpoint',
		// displayModes: [DisplayMode.Panel],
		isVisible: ({ controller: { readonly }}): boolean => !readonly,
		onClick: ({ context, refMap, position, controller }): void => {
			controller.publishRequestedAction('add_breakpoint', context.id, {
				position
			});

			// const refMap = controller?.kitchen?.getReferenceMap(appState.ui.pointer.context.ref.id);

			if (refMap?.type === BlueprintInstanceType.Panel) {
				refMap.panel.breakpoints.new(position.x);
			} else if (refMap?.type === BlueprintInstanceType.Countertop) {
				refMap.countertop.breakpoints.new(position.x);
			}
		}
	}
};
